<template>
    <div class="page">
        <div class="search">
            <div class="df">
                <div class="search-box">
                    <div class="search-item">
                        <div class="label">课程ID:</div>
                        <a-input-number id="inputNumber" v-model="params.courseId" :min="1" placeholder="请输入"
                            style="width: 200px;" />
                    </div>
                    <div class="search-item">
                        <div class="label">课程名称:</div>
                        <a-input placeholder="请输入" v-model="params.courseName"></a-input>
                    </div>
                    <div class="search-item">
                        <div class="label">课程分类:</div>
                        <a-select placeholder="请选择" allowClear v-model="params.classifyId">
                            <a-select-option v-for="(item, index) in $store.getters.getClassify" :key="index"
                                :value="item.id">
                                {{ item.tagName }}
                            </a-select-option>
                        </a-select>
                    </div>
                    <div class="search-item">
                        <div class="label">课程类型:</div>
                        <a-select placeholder="请选择" allowClear v-model="params.cateFirstId">
                            <a-select-option v-for="(item, index) in $store.state.common.courseCateLevel" :key="index"
                                :value="item.id">{{ item.name }}</a-select-option>
                        </a-select>
                    </div>
                    <div class="search-item">
                        <div class="label">审核状态:</div>
                        <a-select placeholder="请选择" v-model="params.status" allowClear>
                            <a-select-option value="3">待提交</a-select-option>
                            <a-select-option value="0">待审核</a-select-option>
                            <a-select-option value="4">初审通过</a-select-option>
                            <a-select-option value="5">复审通过</a-select-option>
                            <a-select-option value="1">审核通过</a-select-option>
                            <a-select-option value="2">审核不通过</a-select-option>
                        </a-select>
                    </div>
                    <a-button type="primary" style="width: 88px;" @click="search()">查询</a-button>
                    <a-button style="width: 88px;margin-left: 12px;" @click="reset()">重置</a-button>
                </div>
                <div class="add-btn">
                    <a-button type="primary" @click="addCourse()">新建课程</a-button>
                </div>
            </div>
            <div class="search-type">
                <a-button class="type-box" :class="item.value === searchType ? 'active' : ''"
                    @click="chooseSearchType(item.value, 1)" v-for="item in typeList" :key="item.value">
                    {{ item.label }}
                </a-button>
            </div>
            <div class="sort df">
                <a class="sort-text" v-for="item in sortList" :key="item.value" @click="chooseSearchType(item.value, 2)"
                    :class="item.value === params.sortType ? 'active1' : ''">
                    {{ item.label }}
                </a>
            </div>
        </div>
        <div class="course" v-if="courseList.length">
            <div class="course-box" v-for="item in courseList" :key="item.id">
                <div class="course-item" @click="openDrawer(item)">
                    <a>
                        <div class="choose" v-if="item.selectStatus == 1">已选</div>
                        <div class="pic">
                            <img v-if="item.coverUrl" :src="item.coverUrl">
                            <img v-else src="../../../public/gateway/course/defaultImg.png">
                        </div>
                        <div class="info">
                            <div class="title">
                                <a-popover>
                                    <template slot="content">
                                        <p>{{ item.courseName }}</p>
                                    </template>
                                    <div class="ellipsis">{{ item.courseName }}</div>
                                </a-popover>
                                <div class="price">¥{{ item.totalPriceText }}</div>
                            </div>
                            <div class="text">
                                ID: {{ item.id }}, {{ item.classHours }}节课, {{ item.studentCount }}人已学习
                            </div>
                            <div class="status">
                                <template v-if="$store.state.common.tags">
                                    <a-tag style="border-radius: 50%; vertical-align: middle; padding: 3px" :color="item.statusText === '审核通过'
                                        ? '#68CC2E'
                                        : item.statusText === '审核不通过'
                                            ? '#FA5151'
                                            : '#FFA91F'
                                        ">
                                    </a-tag>
                                    {{ item.statusText }}
                                </template>
                                <img v-if="item.isPlatform" style="margin-left: 6px;width: 82px; height: 20px"
                                    src="../../assets/isPlatform.png" />
                            </div>
                            <div class="provide">
                                <div class="logo">
                                    <img
                                        :src="item.providerHeadImg ? item.providerHeadImg : '../../../public/gateway/course/institution.png'" />
                                    <a-popover>
                                        <template slot="content">
                                            <p>由{{ item.providerNameList[0] }}提供课程服务</p>
                                        </template>
                                        <span class="ellipsis" style="color: #414141">由{{ item.providerNameList[0] }}提供课程服务</span>
                                    </a-popover>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
            <div class="pagination">
                <a-pagination v-model="params.currentPage" :defaultPageSize="8" :total="pagination.total"
                    show-quick-jumper @change="onChange" :show-total="total => `总共 ${total} 项`" />
            </div>
        </div>
        <div v-else class="empty">
            <a-empty />
        </div>
        <!-- 课程详情 -->
        <CourseCenterDetail v-if="showDrawer" :showDrawer.sync="showDrawer" :courseItem="courseItem" @refresh="getList"
            @edit="addCourse" :courseNeedCheck="courseNeedCheck">
        </CourseCenterDetail>
        <!-- 新建/修改 -->
        <CourseCenterForm v-show="formDrawer" :showDrawer.sync="formDrawer" ref="courseForm" @refresh="getList">
        </CourseCenterForm>
    </div>
</template>

<script>
import CourseCenterDetail from './components/CourseCenterDetail.vue'
import CourseCenterForm from './components/CourseCenterForm.vue'
import bureau from '../../api/bureau'
import course from '../../api/course'
const typeList = [
    { label: '全部', value: -1 },
    { label: '已加入选课', value: 1 },
    { label: '未加入选课', value: 0 },
    { label: '自建课程', value: 2 }
]
const sortList = [
    { label: '综合排序', value: 1 },
    { label: '最新时间', value: 2 },
    { label: '最多报名', value: 3 },
]

export default {
    data() {
        return {
            typeList,
            sortList,
            params: {
                currentPage: 1,
                selectStatus: null,
                sortType: 1,
                pageSize: 8,
                sourceType: null
            },
            searchType: -1,
            pagination: {
                currentPage: 1,
                pageSize: 8,
                total: 0
            },
            courseList: [],
            showDrawer: false, // 详情
            formDrawer: false, // 新建
            courseItem: null,
            courseNeedCheck: false, // 课程是否需要审核
        }
    },
    components: {
        CourseCenterDetail,
        CourseCenterForm
    },
    created() {
        this.getCourseCheckSetting()
        this.getList()
    },
    mounted() {
    },
    methods: {
        reset() {
            this.params.courseId = null
            this.params.courseName = null
            this.params.classifyId = undefined
            this.params.cateFirstId = undefined
            this.params.status = undefined
        },
        search() {
            this.reSetPage()
            this.getList()
        },
        reSetPage() {
            this.params.currentPage = 1
            this.pagination.currentPage = 1
        },
        chooseSearchType(type, num) {
            this.reSetPage()
            if (num == 1) {
                this.searchType = type
                this.params.sourceType = null
                if (type == -1 || type == 2) {
                    delete this.params.selectStatus
                } else {
                    this.params.selectStatus = type
                }
                if (type == 2) {
                    this.params.sourceType = 1
                }
            } else {
                this.params.sortType = type
            }
            this.getList()
        },
        openDrawer(item) {
            this.courseItem = item
            this.showDrawer = true
        },
        addCourse(item) {
            this.formDrawer = true
            this.$nextTick(() => {
                if (item) {
                    this.$refs.courseForm.init('update', item)
                } else {
                    this.$refs.courseForm.init('add')
                }
            })
        },
        getList() {
            course.getCourseCenterList(this.params).then(res => {
                this.courseList = res.data.list
                this.courseList.forEach(item => {
                    item.totalPriceText = (item.totalPrice / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                })
                this.pagination = res.data.pagination
            })
        },
        onChange(e) {
            this.params.currentPage = e
            this.pagination.currentPage = e
            this.getList()
        },

        // 获取学校设置
        getCourseCheckSetting() {
            bureau.getBureauSetting("school_course_status").then(res => {
                if (res.code == 0 && res.data && res.data.length == 1) {
                    this.courseNeedCheck = (res.data[0].settingValue == "1");
                }
            });
        },
    }
}
</script>

<style scoped lang="less">
.page {
    font-size: 14px;
    padding: 20px;
    font-family: PingFangSC, PingFang SC;
    background-color: #f0f2f5;
}

.df {
    display: flex;
}

::v-deep .ant-input,
::v-deep .ant-select {
    width: 200px;
}

.search {
    background-color: #fff;
    width: 100%;
    padding: 24px;
    justify-content: space-between;
    border-bottom: 1px solid #E0E2E4;

    .add-btn {
        margin-left: 20px;
    }

    .search-box {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        margin-bottom: 8px;

        .search-item {
            display: flex;
            width: 33%;
            margin-bottom: 8px;

            .label {
                margin-right: 8px;
                line-height: 32px;
                min-width: 70px;
                color: #171A1D;
            }
        }
    }

    .search-type {
        margin-bottom: 16px;
        display: flex;
        color: #161A1D;

        .type-box {
            margin-right: 10px;
            background: #FFFFFF;
            border-radius: 16px;
            border: 1px solid #E3E3E3;
            line-height: 14px;
        }

        .active {
            background: #3198FF;
            color: #fff;
        }
    }

    .sort-text {
        color: #747778;
        margin-right: 20px;
    }

    .active1 {
        color: #3198FF;
    }
}

.course {
    min-width: 1274px;
    display: flex;
    background-color: #fff;
    padding: 23px;
    flex-wrap: wrap;
    justify-content: flex-start;

    .course-box {
        width: 25%;
        min-width: 292px;
        max-width: 420px;
        margin-bottom: 20px;

        .course-item {
            max-width: 95%;
            min-width: 292px;
            border-radius: 10px;
            border: 1px solid #E3E3E3;
            position: relative;

            .choose {
                position: absolute;
                top: 0;
                left: 0;
                padding: 3px 8px;
                background-color: #3198FF;
                border-radius: 9px 0 10px 0;
                color: #fff;
            }

            .pic {
                width: 100%;
                min-height: 164px;

                img {
                    border-radius: 10px 9px 0 0;
                    min-height: 164px;
                    width: 100%;
                    aspect-ratio: 290 / 164;
                    object-fit: cover;
                }
            }

            .info {
                padding: 12px 16px;

                .title {
                    display: flex;
                    justify-content: space-between;
                    font-size: 15px;
                    color: #333;
                    font-weight: 600;
                    line-height: 21px;


                    .price {
                        color: #FF0000;
                        margin-left: 5px;
                    }
                }

                .text {
                    color: rgba(23, 26, 29, 0.4);
                    margin-top: 10px;
                }

                .status {
                    display: flex;
                    align-items: center;
                    margin: 5px 0;
                    color: #333;
                }

                .provide {
                    background-color: #f7faff;
                    padding: 8px 6px;
                    border-radius: 8px;

                    .logo {
                        display: flex;
                        align-items: center;

                        img {
                            width: 16px;
                            height: 16px;
                        }

                        span {
                            line-height: 16px;
                            margin-left: 8px;
                            color: #414141;
                        }
                    }
                }
            }
        }

    }

    .course-box:nth-child(4n) {
        margin-right: 0;
    }

    .pagination {
        margin-top: 12px;
        width: 100%;
        text-align: center;

        ::v-deep .ant-pagination-item {
            margin: 0 4px !important;
        }

        ::v-deep .ant-pagination-options-quick-jumper {
            margin-left: 12px !important;
        }
    }
}

.ellipsis {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.empty {
    width: 100%;
    height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
}
</style>